module.exports = __webpack_public_path__ + "static/media/send-arrow-2.9dc221b4.svg";